/* @jsxImportSource react */

import config from '@packages/config';

import { SlotsContainer } from './Base/SlotsContainer';
import { AccountSlot } from './IndividualSlots/AccountSlot';
import { WishlistSlot } from './IndividualSlots/WishlistSlot';
import { PaybackSlot } from './IndividualSlots/PaybackSlot';
import { JoeSlot } from './IndividualSlots/JoeSlot';

export const SlotsMinimal = () => {
  const {
    headerSlots: { payback, joe },
  } = config;

  return (
    <SlotsContainer>
      {payback && <PaybackSlot priority={3} />}
      {joe && <JoeSlot priority={3} />}
      <AccountSlot priority={1} />
      <WishlistSlot priority={2} />
    </SlotsContainer>
  );
};
